<template>
  <div class="nx-signing-modal-method-p12">
    <h4>{{$t('DigestInformation')}}</h4>

    <h5 class="mt-4">{{$t('PleaseWait')}}</h5>

    <p class="mt-4">
      <b-spinner />
    </p>
  </div>
</template>

<script>

import { SignApi } from "@/api";
export default {
  props: {
    value: {},
  },
  async created() {
    try {
        //refactor to use for login sign only
        if (this.value.signMethod !== 'SIGN_IAM_SMART'){
          let digests = [];
          const { data } = await SignApi.getDummyDigest();
          digests.push(data);

          this.$emit('input', {
            ...this.value,
            digests: digests
          });
        }else{
          console.log('digest', this.value)
          this.$emit('input', {
            ...this.value
          });
        }
      this.$emit("next");
    } catch (ex) {
      if (ex.response) {
        this.$emit("input", ex.response.data);
        this.$emit("fail");
      } else {
        throw ex;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        DigestInformation: 'Digest all related information',
        PleaseWait: 'Please wait...'
      },
      zh_hk: {
        DigestInformation: '處理所有相關信息',
        PleaseWait: '請稍等...'
      },
      zh_cn: {
        DigestInformation: '处理所有相关信息',
        PleaseWait: '请稍等...'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-method-p12 {
  text-align: center;
}
</style>
